import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isLoading: false, // Global boolean, true if ajax calls in progress
        baseHref: "", // Subdomain where the software is running ie. "/ContactForms"
        activeLang: "fi", // Current language, default fi
        contentServiceUrl: "",
        ajoneuvoverolaskuriLists: [],
        nedcMap: new Map<number, number>(),
        nedcMapPost2025: new Map<number, number>(),
        wltpMap: new Map<number, number>(),
        wltpMapPost2025: new Map<number, number>(),
        vakSearchResults: [],
        vakSearchValue: "",
        columnCodeLinks: [],
        vakApiCallFailed: false,
        lkpLaskuriConfigs: null,
        embeddedPdfFiles: [],
        basicAndPowerTax: { basicTax: null, powerTax: null },
        mainLoaded: false
    },
    mutations: {
        setLoading(state, isLoading: boolean) {
            state.isLoading = isLoading
        },
        setBaseHref(state, baseHref: string) {
            if (state.baseHref === "") { // BaseHref can only be assigned once
                state.baseHref = baseHref
            }
        },
        setLang(state, lang: string) {
            if (lang === "fi" || lang === "sv" || lang === "en") {
                state.activeLang = lang
                Vue.i18n.set(lang)
            }
        },
        setContentServiceUrl(state, newUrl: string) {
            state.contentServiceUrl = newUrl
        },
        setAjoneuvoverolaskuriLists(state, lists) {
            state.ajoneuvoverolaskuriLists = lists
        },
        setNedcMap(state, nedcMap) {
            state.nedcMap = nedcMap
        },
        setNedcMapPost2025(state, nedcMap) {
            state.nedcMapPost2025 = nedcMap
        },
        setWltpMap(state, wltpMap) {
            state.wltpMap = wltpMap
        },
        setWltpMapPost2025(state, wltpMap) {
            state.wltpMapPost2025 = wltpMap
        },
        setVakSearchResults(state, results) {
            state.vakSearchResults = results
        },
        setVAKSearchValue(state, searchValue) {
            state.vakSearchValue = searchValue
        },
        setColumnCodeLinks(state, links) {
            state.columnCodeLinks = links
        },
        setVakApiCallFailed(state, bit) {
            state.vakApiCallFailed = bit
        },
        setLKPLaskuriConfigs(state, configs) {
            state.lkpLaskuriConfigs = configs
        },
        setEmbeddedPdfFiles(state, files) {
            state.embeddedPdfFiles = files
        },
        setBasicAndPowerTax(state, taxes) {
            state.basicAndPowerTax = taxes
        },
        setMainLoaded(state, loaded) {
            state.mainLoaded = loaded
        }
    },
    actions: {
        setLoading(state, isLoading: boolean) {
            state.commit("setLoading", isLoading)
        },
        setBaseHref(state, baseHref: string) {
            state.commit("setBaseHref", baseHref)
        },
        setLang(state, lang: string) {
            state.commit("setLang", lang)
        },
        setContentServiceUrl(state, newUrl: string) {
            state.commit("setContentServiceUrl", newUrl)
        },
        setAjoneuvoverolaskuriLists(state, lists) {
            state.commit("setAjoneuvoverolaskuriLists", lists)
        },
        setNedcMap(state, nedcMap) {
            state.commit("setNedcMap", nedcMap)
        },
        setNedcMapPost2025(state, nedcMap) {
            state.commit("setNedcMapPost2025", nedcMap)
        },
        setWltpMap(state, wltpMap) {
            state.commit("setWltpMap", wltpMap)
        },
        setWltpMapPost2025(state, wltpMap) {
            state.commit("setWltpMapPost2025", wltpMap)
        },
        setVakSearchResults(state, results) {
            state.commit("setVakSearchResults", results)
        },
        setVAKSearchValue(state, searchValue) {
            state.commit("setVAKSearchValue", searchValue)
        },
        setColumnCodeLinks(state, links) {
            state.commit("setColumnCodeLinks", links)
        },
        setVakApiCallFailed(state, bit) {
            state.commit("setVakApiCallFailed", bit)
        },
        setLKPLaskuriConfigs(state, configs) {
            state.commit("setLKPLaskuriConfigs", configs)
        },
        setEmbeddedPdfFiles(state, files) {
            state.commit("setEmbeddedPdfFiles", files)
        },
        setBasicAndPowerTax(state, taxes) {
            state.commit("setBasicAndPowerTax", taxes)
        },
        setMainLoaded(state, loaded) {
            state.commit("setMainLoaded", loaded)
        }
    },
    getters: {
        isLoading: (state) => {
            return state.isLoading
        },
        baseHref: (state) => {
            return state.baseHref
        },
        activeLang: (state) => {
            return state.activeLang
        },
        contentServiceUrl: (state) => {
            return state.contentServiceUrl
        },
        ajoneuvoverolaskuriLists: (state) => {
            return state.ajoneuvoverolaskuriLists
        },
        nedcMap: (state) => {
            return state.nedcMap
        },
        nedcMapPost2025: (state) => {
            return state.nedcMapPost2025
        },
        wltpMap: (state) => {
            return state.wltpMap
        },
        wltpMapPost2025: (state) => {
            return state.wltpMapPost2025
        },
        vakSearchResults: (state) => {
            return state.vakSearchResults
        },
        vakSearchValue: (state) => {
            return state.vakSearchValue
        },
        columnCodeLinks: (state) => {
            return state.columnCodeLinks
        },
        vakApiCallFailed: (state) => {
            return state.vakApiCallFailed
        },
        lkpLaskuriConfigs: (state) => {
            return state.lkpLaskuriConfigs
        },
        embeddedPdfFiles: (state) => {
            return state.embeddedPdfFiles
        },
        basicAndPowerTax(state) {
            return state.basicAndPowerTax
        },
        mainLoaded(state) {
            return state.mainLoaded
        }
    },
    modules: {
    }
})
